export default __webpack_public_path__ + "static/media/pdf_icon.007b449d.svg";